<template>
    <div>
        <!--Desktop Header-->
        <div class="d-none d-md-flex" style="margin:0; padding:0; width:100%;">
            <div class="header" style="width:100%">

                <!--Top bar-->
                <div class="topBar">
                    <div class="topBarLeft">
                        <a class="topBarAddress">
                            <img class="topBarIcon" src="/Resources/images/icon/location.png"/>
                            924, rue Saint Pierre, Drummondville QC J2C 3Y2
                        </a>
                    </div>
                    <div class="topBarRight">
                        <router-link class="topBarLink" to="/contact">{{ $t('menu.contact') }}</router-link>
                        <a class="smIcon" href="https://www.facebook.com/BissonService" target="_blank" title="Facebook Bisson Service"></a>
                    </div>
                </div>

                <!--Nav bar-->
                <div class="navBar">
                    <div class="navLogo">
                        <router-link to="/">
                            <img @click="home" class="logoImg" src="/Resources/images/logo/logo.png"/>
                        </router-link>
                    </div>
                    <ul class="menu">
                        <li>
                            <router-link class="menuLink" to="/armstrong" v-html="$t('menu.Armstrong')"></router-link>
                        </li>
                        <li>
                            <router-link class="menuLink" to="/laveuse_haute_pression" v-html="$t('menu.highPressureWasher')"></router-link>
                        </li>
                        <li>
                            <router-link class="menuLink" to="/filtre_a_eau">{{ $t('menu.treatment') }}</router-link>
                        </li>
                        <li>
                            <router-link class="menuLink" to="/pompes">{{ $t('menu.pump') }}</router-link>
                        </li>
                        <li class="hasDropdown">
                            <router-link class="menuLink"  to="/services" v-html="$t('menu.services')"></router-link>
                            <div class="dropdown-content">
                                <router-link to="/services#emergency" v-html="$t('menu.services1')"></router-link>
                                <router-link to="/analyseEau" v-html="$t('menu.waterAnalysis')"></router-link>
                                <router-link to="/RéparationPompe" v-html="$t('menu.services2')"></router-link>
                                <router-link to="/services#repairEngine">Réparation de moteurs électriques</router-link>
                                <router-link to="/services#artesianWell" v-html="$t('menu.services4')"></router-link>
                                <router-link to="/services#pressureController" v-html="$t('menu.services5')"></router-link>
                                <router-link to="/vaccum" class="vacuumLink">Services Vacuum</router-link>
                                <router-link to="/forage" class="vacuumLink">Forage de puits</router-link>
                            </div>
                        </li>
                        <li class="hasDropdown">
                            <router-link class="menuLink" to="/produits">{{ $t('menu.products') }}</router-link>
                            <div class="dropdown-content">
                                <router-link to="/produits">Tous les produits</router-link>
                                <router-link to="/PVC40">Tuyaux PVC Cédule 40</router-link>
                                <router-link to="/PVC80">Tuyaux PVC Cédule 80</router-link>
                            </div>
                        </li>
                        <li>
                            <router-link class="menuLink" to="/experts">{{ $t('menu.experts') }}</router-link>
                        </li>
                    </ul>
                </div>

            </div>
        </div>

        <!--Mobile menu-->
        <div class="d-flex d-md-none">

            <!-- App Bar mobile -->
            <div class="mobileBar">
                <button class="hamburgerBtn" @click="drawer = !drawer">
                    <span class="hamburgerLine" :class="{ active: drawer }"></span>
                    <span class="hamburgerLine" :class="{ active: drawer }"></span>
                    <span class="hamburgerLine" :class="{ active: drawer }"></span>
                </button>
                <router-link to="/" class="mobileBarLogo">
                    <img src="/Resources/images/logo/logo.png"/>
                </router-link>
                <a class="mobileBarPhone" href="tel:8194727904">
                    <img src="/Resources/images/icon/phone.png" style="width:22px; height:22px;"/>
                </a>
            </div>

            <!-- Overlay fond sombre -->
            <transition name="fade-overlay">
                <div v-if="drawer" class="mobileOverlay" @click="drawer = false"></div>
            </transition>

            <!-- Drawer latéral gauche -->
            <transition name="slide-drawer">
                <div v-if="drawer" class="mobileDrawer">

                    <!-- Header drawer -->
                    <div class="drawerHeader">
                        <img src="/Resources/images/logo/logoFooter.png" class="drawerLogo"/>
                        <button class="drawerClose" @click="drawer = false">✕</button>
                    </div>

                    <!-- Navigation -->
                    <nav class="drawerNav">

                        <router-link to="/armstrong" class="drawerLink" @click.native="drawer = false">Armstrong</router-link>
                        <router-link to="/laveuse_haute_pression" class="drawerLink" @click.native="drawer = false">Laveuse à pression</router-link>
                        <router-link to="/filtre_a_eau" class="drawerLink" @click.native="drawer = false">Traitements</router-link>
                        <router-link to="/pompes" class="drawerLink" @click.native="drawer = false">Pompes à eau</router-link>

                        <!-- Services accordion -->
                        <div class="drawerAccordion">
                            <button class="drawerAccordionBtn" @click="servicesOpen = !servicesOpen">
                                <span style="font-weight: bold;">Services</span>
                                <svg class="accordionArrow" :class="{ rotated: servicesOpen }" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
                            </button>
                            <div class="drawerSubLinks" v-show="servicesOpen">
                                <router-link to="/services#emergency" class="drawerSubLink" @click.native="drawer = false" v-html="$t('menu.services1')"></router-link>
                                <router-link to="/analyseEau" class="drawerSubLink" @click.native="drawer = false" v-html="$t('menu.waterAnalysis')"></router-link>
                                <router-link to="/RéparationPompe" class="drawerSubLink" @click.native="drawer = false" v-html="$t('menu.services2')"></router-link>
                                <router-link to="/services#repairEngine" class="drawerSubLink" @click.native="drawer = false">Réparation de moteurs électriques</router-link>
                                <router-link to="/services#artesianWell" class="drawerSubLink" @click.native="drawer = false" v-html="$t('menu.services4')"></router-link>
                                <router-link to="/services#pressureController" class="drawerSubLink" @click.native="drawer = false" v-html="$t('menu.services5')"></router-link>
                                <router-link to="/vaccum" class="drawerSubLink" @click.native="drawer = false">Services Vacuum</router-link>
                                <router-link to="/forage" class="drawerSubLink" @click.native="drawer = false">Forage de puits</router-link>
                            </div>
                        </div>

                        <!-- Produits accordion -->
                        <div class="drawerAccordion">
                            <button class="drawerAccordionBtn" @click="produitsOpen = !produitsOpen">
                                <span style="font-weight: bold;">Produits</span>
                                <svg class="accordionArrow" :class="{ rotated: produitsOpen }" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
                            </button>
                            <div class="drawerSubLinks" v-show="produitsOpen">
                                <router-link to="/produits" class="drawerSubLink" @click.native="drawer = false">Tous les produits</router-link>
                                <router-link to="/PVC40" class="drawerSubLink" @click.native="drawer = false">Tuyaux PVC Cédule 40</router-link>
                                <router-link to="/PVC80" class="drawerSubLink" @click.native="drawer = false">Tuyaux PVC Cédule 80</router-link>
                            </div>
                        </div>
                        <router-link to="/experts" class="drawerLink" @click.native="drawer = false">Les Experts</router-link>
                        <router-link to="/contact" class="drawerLink drawerLinkCta" @click.native="drawer = false">Nous contacter</router-link>

                    </nav>

                    <!-- Footer du drawer -->
                    <div class="drawerFooter">
                        <a href="tel:819-472-7904" class="drawerFooterPhone">819 472-7904</a>
                        <p class="drawerFooterAddress">924, rue Saint-Pierre, Drummondville</p>
                    </div>

                </div>
            </transition>

        </div>
    </div>
</template>

<style scoped>

  /*#region Top Bar*/
  .header { width: 100%; margin: 0; padding: 0; }
  .topBar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 30px;
    background-color: rgb(var(--secondary));
    font-size: 13px;
  }
  .topBarLeft { display: flex; align-items: center; gap: 8px; }
  .topBarRight { display: flex; align-items: center; gap: 16px; }
  .topBarAddress {
    color: rgba(255,255,255,0.9);
    font-size: 13px;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .topBarIcon { height: 12px; width: 12px; filter: brightness(10); }
  .topBarLink {
    color: rgba(255,255,255,0.9);
    text-decoration: none;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.5px;
    transition: color 0.2s;
  }
  .topBarLink:hover { color: #ffffff; }
  .smIcon {
    height: 22px;
    width: 22px;
    background-image: url(./../../public/Resources/images/sm/facebook-25x25.svg);
    background-size: contain;
    background-repeat: no-repeat;
    display: block;
    transition: opacity 0.2s;
  }
  .smIcon:hover { background-image: url(./../../public/Resources/images/sm/facebook-25x25-Hover.svg); }
  /*#endregion*/

  /*#region Nav Bar*/
  .navBar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 30px;
    background-color: #ffffff;
    position: relative;
    overflow: visible;
    height: 103px;
  }
  /* Shimmer sous le menu */
  .navBar::after {
    content: '';
    position: absolute;
    bottom: -3px;
    left: -100%;
    width: 60%;
    height: 3px;
    background: linear-gradient(
      90deg,
      transparent 0%,
      rgba(var(--primary), 0.15) 20%,
      rgba(var(--primary), 0.6) 50%,
      rgba(var(--primary), 0.15) 80%,
      transparent 100%
    );
    animation: shimmerNav 3.5s ease-in-out infinite;
    border-radius: 2px;
  }
  @keyframes shimmerNav {
    0%   { left: -60%; }
    100% { left: 110%; }
  }
  .navLogo { max-width: 160px; }
  .logoImg { height: auto; width: 100%; }
  /*#endregion*/

  /*#region Desktop Menu*/
  .menu {
    display: flex;
    align-items: center;
    list-style: none;
    margin: 0;
    padding: 0;
    gap: 4px;
  }
  .menu:hover {text-decoration: none;}
  .menu li { position: relative; }
  .menuLink {
    display: block;
    padding: 8px 12px;
    color: rgb(var(--secondary));
    text-decoration: none;
    font-size: 13px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    transition: color 0.25s ease;
  }
  .menuLink:hover { color: rgb(var(--primary)); text-decoration: none !important; }
  a:hover { text-decoration:none !important; }
  /* Active route */
  .menuLink.router-link-active { color: rgb(var(--primary)); }
  /*#endregion*/

  /*#region Dropdown*/
  .hasDropdown:hover .dropdown-content { display: block; }
  .dropdown-content {
    display: none;
    position: absolute;
    top: 100%; /* Pas de gap — collé au menu item */
    right: 0;
    min-width: 280px;
    white-space: nowrap;
    background-color: #ffffff;
    border-top: 3px solid rgb(var(--primary));
    box-shadow: 0 8px 24px rgba(0,0,0,0.15);
    border-radius: 0 0 6px 6px;
    z-index: 1000;
    overflow: hidden;
    padding-top: 6px; /* Espace visuel SANS briser le hover */
  }
  .dropdown-content a {
    display: block;
    padding: 11px 18px;
    color: rgb(var(--secondary));
    text-decoration: none !important;
    font-size: 13px;
    font-weight: 600;
    text-align: right;
    transition: background-color 0.2s, color 0.2s;
    border-bottom: none;
  }
  /* Alternance bleu / blanc */
  .dropdown-content a:nth-child(odd)  { background-color: #ffffff; }
  .dropdown-content a:nth-child(even) { background-color: rgba(var(--secondary), 0.08); }
  .dropdown-content a:hover {
    background-color: rgb(var(--primary)) !important;
    color: #ffffff !important;
    text-decoration: none !important;
  }
  .vacuumLink {
    font-style: italic;
    border-top: 2px solid rgba(var(--primary), 0.2) !important;
  }
  /*#endregion*/

  /*#region Mobile Bar*/
  .mobileBar {
    position: fixed;
    top: 0; left: 0; right: 0;
    height: 60px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    z-index: 999;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    border-bottom: 3px solid rgb(var(--primary));
  }
  .hamburgerBtn {
    background: none; border: none; cursor: pointer;
    display: flex; flex-direction: column; gap: 5px; padding: 4px;
  }
  .hamburgerLine {
    display: block; width: 24px; height: 2.5px;
    background-color: rgb(var(--secondary));
    border-radius: 2px;
    transition: transform 0.3s ease, opacity 0.3s ease;
  }
  .mobileBarLogo img { height: 42px; width: auto; }
  .mobileBarPhone {
    color: rgb(var(--secondary));
    display: flex; align-items: center;
    padding: 6px;
  }
  .mobileBarPhone:hover { color: rgb(var(--primary)); }
  /*#endregion*/

  /*#region Overlay*/
  .mobileOverlay {
    position: fixed; inset: 0;
    background-color: rgba(0,0,0,0.5);
    z-index: 1000;
    backdrop-filter: blur(2px);
  }
  .fade-overlay-enter-active, .fade-overlay-leave-active { transition: opacity 0.3s ease; }
  .fade-overlay-enter, .fade-overlay-leave-to { opacity: 0; }
  /*#endregion*/

  /*#region Drawer latéral*/
  .mobileDrawer {
    position: fixed;
    top: 0; left: 0; bottom: 0;
    width: 82%;
    max-width: 320px;
    background-color: #ffffff;
    z-index: 1001;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    box-shadow: 4px 0 20px rgba(0,0,0,0.2);
  }
  .slide-drawer-enter-active, .slide-drawer-leave-active { transition: transform 0.35s ease; }
  .slide-drawer-enter, .slide-drawer-leave-to { transform: translateX(-100%); }

  /* Header drawer */
  .drawerHeader {
    background: linear-gradient(135deg, rgb(var(--secondary)), rgba(var(--secondary), 0.85));
    padding: 20px 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
  }
  .drawerLogo { height: 50px; width: auto; }
  .drawerClose {
    background: none; border: none; cursor: pointer;
    color: rgba(255,255,255,0.8); font-size: 22px; line-height: 1;
    padding: 4px 8px; border-radius: 4px;
    transition: color 0.2s, background-color 0.2s;
  }
  .drawerClose:hover { color: #fff; background-color: rgba(255,255,255,0.15); }

  /* Navigation */
  .drawerNav { flex: 1; padding: 10px 0; }
  .drawerLink {
    display: flex; align-items: center;
    padding: 14px 22px;
    color: rgb(var(--secondary));
    text-decoration: none;
    font-size: 15px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid rgba(var(--secondary), 0.07);
    transition: background-color 0.2s, color 0.2s, padding-left 0.2s;
  }
  .drawerLink:hover, .drawerLink.router-link-active {
    background-color: rgba(var(--primary), 0.06);
    color: rgb(var(--primary));
    padding-left: 28px;
  }
  .drawerLinkCta {
    color: rgb(var(--primary));
    border-top: 2px solid rgba(var(--primary), 0.15);
    margin-top: 6px;
  }

  /* Accordion Services */
  .drawerAccordion { border-bottom: 1px solid rgba(var(--secondary), 0.07); }
  .drawerAccordionBtn {
    width: 100%;
    display: flex; align-items: center; justify-content: space-between;
    padding: 14px 22px;
    background: none; border: none; cursor: pointer;
    color: rgb(var(--secondary));
    font-size: 15px; font-weight: 700;
    text-transform: uppercase; letter-spacing: 0.5px;
    border-bottom: 1px solid rgba(var(--secondary), 0.07);
    transition: background-color 0.2s, color 0.2s;
  }
  .drawerAccordionBtn:hover { background-color: rgba(var(--primary), 0.06); color: rgb(var(--primary)); }
  .accordionArrow { transition: transform 0.3s ease; flex-shrink: 0; }
  .accordionArrow.rotated { transform: rotate(180deg); }
  .drawerSubLinks { }
  /* Alternance bleu/gris sous-menu */
  .drawerSubLink {
    display: block;
    padding: 12px 22px 12px 36px;
    text-decoration: none;
    font-size: 14px;
    font-weight: 600;
    transition: background-color 0.2s, color 0.2s, padding-left 0.2s;
  }
  .drawerSubLink:nth-child(odd)  { background-color: rgba(var(--secondary), 0.06); color: rgb(var(--secondary)); }
  .drawerSubLink:nth-child(even) { background-color: #ffffff; color: rgb(var(--secondary)); }
  .drawerSubLink:hover { background-color: rgb(var(--primary)) !important; color: #ffffff !important; padding-left: 42px; }

  /* Footer drawer */
  .drawerFooter {
    padding: 18px 22px;
    border-top: 2px solid rgba(var(--secondary), 0.1);
    background-color: rgba(var(--secondary), 0.03);
    flex-shrink: 0;
  }
  .drawerFooterPhone {
    display: block;
    font-size: 18px; font-weight: 800;
    color: rgb(var(--secondary));
    text-decoration: none;
    margin-bottom: 4px;
  }
  .drawerFooterPhone:hover { color: rgb(var(--primary)); }
  .drawerFooterAddress { font-size: 13px; color: rgba(var(--menuColor), 0.55); margin: 0; }
  /*#endregion*/

  @media handheld, only screen and (max-width: 450px) {
    .drawer { width: 100% !important; }
  }
  @media handheld, only screen and (max-width: 1279px) {
    .navBar { padding: 8px 15px; }
    .topBar { padding: 5px 15px; }
    .navLogo { max-width: 120px; }
    .menuLink { font-size: 11px; padding: 8px 7px; }
  }
</style>

<script>
import translations from '../../public/Resources/i18N/global.json';
export default {
    name: 'Header',
    data: () => ({
        drawer: false,
        servicesOpen: false,
        produitsOpen: false,
    }),
    mounted() {
        this.$i18n.mergeLocaleMessage('fr', translations.fr);
        this.$i18n.mergeLocaleMessage('en', translations.en);
    },
    methods: {
        home: function () { this.$router.push('/'); },
        switchLanguage: function () {
            this.$i18n.locale = this.currentLang() === 'en' ? 'fr' : 'en';
        },
        currentLang() {
            return this.$i18n.locale;
        },
    },
    component: {}
}
</script>